var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "relative"
  }, [_c('div', {
    ref: "scroll",
    staticClass: "overflow-auto pa-1 scroll-container",
    staticStyle: {
      "white-space": "nowrap"
    },
    style: {
      'mask-image': `linear-gradient(90deg, #FFF${_vm.left ? '0' : 'F'}, #FFFF 80px, #FFFF calc(100% - 80px), #FFF${_vm.right ? '0' : 'F'})`
    },
    on: {
      "scroll": _vm.updateScroll
    }
  }, [_vm._t("default")], 2), !_vm.IS_TOUCH ? _c('div', {
    staticClass: "absolute-fill d-flex align-center pa-1",
    staticStyle: {
      "pointer-events": "none"
    }
  }, [_vm.left ? _c('v-btn', {
    staticStyle: {
      "pointer-events": "auto"
    },
    attrs: {
      "fab": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$refs.scroll.scrollTo({
          left: _vm.$refs.scroll.scrollLeft - _vm.$refs.scroll.offsetWidth,
          behavior: 'smooth'
        });
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronLeft)
    }
  })], 1) : _vm._e(), _c('v-spacer'), _vm.right ? _c('v-btn', {
    staticStyle: {
      "pointer-events": "auto"
    },
    attrs: {
      "fab": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$refs.scroll.scrollTo({
          left: _vm.$refs.scroll.scrollLeft + _vm.$refs.scroll.offsetWidth,
          behavior: 'smooth'
        });
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1) : _vm._e()], 1) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }